import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../hooks/useAuth";
import { IoWarningOutline } from "react-icons/io5";

/**
 * Shows a blocking modal for users who have at least one card saved
 * without a card number (i.e. added before the new cardNo requirement).
 * They must complete their card info before using the platform.
 * The modal disappears automatically on /my-account/manage-cards.
 */
export default function IncompleteCardModal() {
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();

  // Only applies to users with cards where at least one is missing the card number
  const hasIncompleteCard =
    Array.isArray(user?.cards) &&
    user.cards.length > 0 &&
    user.cards.some((c) => !c.card || c.card.trim() === "");

  // Don't block the manage-cards page itself — that's where they fix it
  const isOnManageCards = location.pathname === "/my-account/manage-cards";

  if (!hasIncompleteCard || isOnManageCards) return null;

  return (
    /* Full-screen overlay — pointer-events block all interaction underneath */
    <div
      className="fixed inset-0 z-[9999] flex items-end justify-center"
      style={{ background: "rgba(0,0,0,0.55)" }}
    >
      <div className="w-full sm:max-w-[500px] bg-white rounded-t-3xl px-5 pt-6 pb-10 flex flex-col gap-4 shadow-2xl animate-slide-up">

        {/* handle */}
        <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto mb-1" />

        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
            <IoWarningOutline className="text-amber-500 text-xl" />
          </span>
          <div>
            <p className="font-bold text-gray-800">تکمیل اطلاعات کارت بانکی</p>
            <p className="text-xs text-gray-500 mt-0.5">برای ادامه استفاده از پلتفرم لازم است</p>
          </div>
        </div>

        <p className="text-sm text-gray-600 leading-7">
          در به‌روزرسانی جدید، ثبت <strong>شماره کارت</strong> به همراه شماره شبا
          الزامی شده است. یکی از کارت‌های ثبت‌شده شما شماره کارت ندارد.
          <br />
          لطفاً کارت قدیمی را حذف و با اطلاعات کامل (شبا + شماره کارت) مجدداً
          ثبت کنید.
        </p>

        <button
          onClick={() => navigate("/my-account/manage-cards")}
          className="w-full py-3 bg-primary text-white font-semibold rounded-xl text-sm"
        >
          رفتن به مدیریت کارت‌ها
        </button>
      </div>
    </div>
  );
}
